import { render, staticRenderFns } from "./referansagore.vue?vue&type=template&id=bc8ec44e&"
import script from "./referansagore.vue?vue&type=script&lang=js&"
export * from "./referansagore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports